import React from 'react'
import { spacing } from '@mobi/component-library/Foundations'
import { InfoHeader } from '@mobi/component-library/Typography/InfoHeader'

export const NoSearchResults: React.FC = () => {
  return (
    <div style={{ paddingTop: spacing.lg }}>
      <InfoHeader
        size='large'
        icon='warning'
        header='No Results Found'
        subHeader='Sorry, we couldn’t find what you’re looking for.'
      />
    </div>
  )
}
